import React from "react";
import { Row, Button, Modal, ModalBody, ModalFooter } from "reactstrap";

// Strings
import { getMessage } from "CONFIG/i18n";
import modalScrollBar from "../ModalScrollBar/ModalScrollBar";

import "./Login.less";

class MfaErrorModal extends React.Component {

  handleOkClick = () => {
    this.props.handleMfaEnableOkClick(this.props.mfaLoginResponse);
  };

  render() {
    return (
      <Modal isOpen={this.props.show} className="mfaModal" backdrop="static">
        <ModalBody>
          <Row>
            <label className="MfaMsgLabel text-left autoHeight">
              {getMessage("MFA_SETTING_ENABLED_MSG")}</label>
          </Row>
        </ModalBody>
        <ModalFooter className="permissionButtons">
          <Button
            className="customBtn borderBtn whiteOnClick"
            onClick={()=>this.handleOkClick()}
          >
            {getMessage("OK")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default modalScrollBar(MfaErrorModal);
